import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Button, CloseButton } from '@instructure/ui-buttons';
import { Text } from '@instructure/ui-text';
import { Heading } from '@instructure/ui-heading';
import t from '@instructure/quiz-i18n/es/format-message';
import { Modal, ModalHeader, ModalBody, ModalFooter, MOVED_IN_SIDEBAR, XSMALL_SIDE_MARGIN } from '@instructure/quiz-common';
export var MoveImmutableModal = /*#__PURE__*/function (_Component) {
  function MoveImmutableModal() {
    var _this;
    _classCallCheck(this, MoveImmutableModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, MoveImmutableModal, [].concat(args));
    _defineProperty(_this, "handleSubmit", function (e) {
      var _this$props = _this.props,
        quizId = _this$props.quizId,
        position = _this$props.position,
        stimulusQuizEntryId = _this$props.stimulusQuizEntryId,
        quizEntry = _this$props.quizEntry;
      _this.props.closeModal();
      _this.props.setUI(MOVED_IN_SIDEBAR, _this.props.movedInSidebar);
      _this.props.moveImmutableQuizEntry(quizId, position, stimulusQuizEntryId, quizEntry.id);
    });
    _defineProperty(_this, "closeAction", function () {
      _this.props.closeModal();
    });
    return _this;
  }
  _inherits(MoveImmutableModal, _Component);
  return _createClass(MoveImmutableModal, [{
    key: "cancelButton",
    value: function cancelButton() {
      return /*#__PURE__*/React.createElement(Button, {
        onClick: this.closeAction,
        margin: XSMALL_SIDE_MARGIN
      }, t('Cancel'));
    }
  }, {
    key: "doneButton",
    value: function doneButton() {
      return /*#__PURE__*/React.createElement(Button, {
        color: "primary",
        onClick: this.handleSubmit,
        margin: XSMALL_SIDE_MARGIN
      }, t('Clone and Move'));
    }
  }, {
    key: "renderBody",
    value: function renderBody() {
      return /*#__PURE__*/React.createElement("div", null, t('Moving to this position will clone the question and change ' + 'its associated stimulus as students have already begun to answer it.'));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(Modal, {
        open: this.props.modalOpen,
        onDismiss: this.closeAction,
        size: "small",
        label: t('Confirm Clone and Move')
      }, /*#__PURE__*/React.createElement(ModalHeader, null, /*#__PURE__*/React.createElement(Heading, {
        level: "reset",
        as: "h2"
      }, t('Confirm Clone and Move')), /*#__PURE__*/React.createElement(CloseButton, {
        onClick: this.closeAction,
        placement: "end",
        offset: "medium",
        screenReaderLabel: t('Close')
      })), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(Text, {
        color: "primary"
      }, this.renderBody())), /*#__PURE__*/React.createElement(ModalFooter, null, this.cancelButton(), this.doneButton()));
    }
  }]);
}(Component);
_defineProperty(MoveImmutableModal, "propTypes", {
  closeModal: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  moveImmutableQuizEntry: PropTypes.func.isRequired,
  movedInSidebar: PropTypes.bool,
  position: PropTypes.number,
  quizEntry: ImmutablePropTypes.record,
  quizId: PropTypes.string,
  setUI: PropTypes.func.isRequired,
  stimulusQuizEntryId: PropTypes.string
});
_defineProperty(MoveImmutableModal, "defaultProps", {
  movedInSidebar: false,
  position: void 0,
  quizEntry: void 0,
  quizId: void 0,
  stimulusQuizEntryId: void 0
});
export default MoveImmutableModal;